(function (a, b) {
  const loader = a.createElement('script');
  loader.type = 'text/javascript';
  loader.src = 'https://app-cdn.puzzel.com/public/js/pzl_loader.js';
  loader.setAttribute('id', 'pzlModuleLoader');
  loader.setAttribute('data-customer-id', b);
  a.body.append(loader);
})(document, '1302672');